export default function OurFeatures() {
  return (
    <section class="services" id="services">
    <h2>Our Features</h2>
    <div class="service-grid">
      <div class="service-card">
        <i class="fas fa-tools"></i>
        <h3>Near by garages </h3>
        <p>Choose from a wide range of high-performance bikes available for short or long rides.</p>
      </div>
      <div class="service-card">
        <i class="fas fa-handshake"></i>
        <h3>Comminity building</h3>
        <p>Personalize your bike’s look and performance with expert-level customizations.</p>
      </div>
      <div class="service-card">
        <i class="fas fa-exclamation-triangle"></i>
        <h3>SOS</h3>
        <p>Enhance your bike’s speed, control, and responsiveness with precision tuning.</p>
      </div>
      <div class="service-card">
        <i class="fas fa-motorcycle"></i>
        <h3>Rent a bike</h3>
        <p>Buy certified used bikes or sell yours easily with our transparent marketplace.</p>
      </div>
    </div>
  </section>
        )
}